import React from "react";
import RecievedFlagsData from "../admin/RecievedFlagsData";
import GivenFlagsData from "./GivenFlagsData";
import { Link } from "react-router-dom";
const FlagTabs = ({ id }) => {
  return (
    <div className="EventsTabs">
      <div className="container-fluid">
        <div>
          <Link to={`/view-user-detail/${id}`}>
            {" "}
            <i
              className="fas fa-solid fa-arrow-left"
              style={{ color: "#6a7187", marginRight: 2 }}
            />{" "}
            Back
          </Link>
        </div>
        <div className="card user-card shadow mb-4">
          <div className="card-header py-3">
            <h6 className="m-0 font-weight-bold text-primary">Flags</h6>
          </div>
          <div className="card-body">
            <div className="tabs-wrap">
              <ul
                className="nav nav-tabs events-tabs"
                id="myTab"
                role="tablist"
              >
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    id="Recieved-rating"
                    data-toggle="tab"
                    href="#rating"
                    role="tab"
                    aria-controls="settings"
                    aria-selected="true"
                  >
                    Recieved Flags
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="given-rating-tab"
                    data-toggle="tab"
                    href="#given-rating"
                    role="tab"
                    aria-controls="Attendees"
                    aria-selected="false"
                  >
                    Given Flags
                  </a>
                </li>
              </ul>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane flags fade show active"
                  id="rating"
                  role="tabpanel"
                  aria-labelledby="Recieved-rating"
                >
                  <RecievedFlagsData id={id} />
                </div>
                <div
                  className="tab-pane fade"
                  id="given-rating"
                  role="tabpanel"
                  aria-labelledby="given-rating-tab"
                >
                  <GivenFlagsData id={id} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlagTabs;
